<template>
<svg viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-DuoLeiXingKaCaoXuanZhong`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.48718 12.2809L12.4878 14.8867 15.1822 16.35 23.291 12.0479M15.1354 16.4434V24.4751" stroke="#333" stroke-width="1.5" stroke-linecap="round"/><path d="M6.47125 11.6794L14.9335 7.34482C14.99 7.31589 15.0568 7.31547 15.1137 7.3437L23.8435 11.68C23.9115 11.7138 23.9545 11.7832 23.9545 11.8591V20.5888C23.9545 20.6611 23.9155 20.7277 23.8526 20.7631L15.1229 25.6761C15.0612 25.7108 14.9857 25.7103 14.9244 25.6748L6.46204 20.7636C6.40038 20.7278 6.36243 20.6619 6.36243 20.5906V11.8574C6.36243 11.7824 6.40445 11.7137 6.47125 11.6794Z" stroke="#333" stroke-width="1.5" stroke-linecap="round"/><path d="M23.2504 12.8486L15.786 16.8177V24.5095L23.2504 20.3275V12.8486Z" :fill="useCurrentColor ? 'currentColor' : '#DCBFF5'"/><path d="M6.44406 11.4836L4.97388 7.51074M14.8813 7.0861L13.8471 3.45021M13.7834 3.48341L4.98193 7.52842" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconDuoLeiXingKaCaoXuanZhong',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
